export const FOOTER_TEST_ID = {
  footer: 'footer',
  footerCloverLogo: 'footer-clover-logo',
};
